<template>
<v-card outlined rounded class="mt-4 mr-4">
    <v-card-text>
        <p class="text-h6 text--primary mb-10">
            {{title}} <span v-if="percent" class="subtitle-1">({{percent}}%)</span>
        </p>
        <VueApexCharts type="bar" height="100%" :options="chartInfo.options" :series="chartInfo.series"></VueApexCharts>
    </v-card-text>
    <!-- <v-card-text v-else>
        {{title}} : no data
    </v-card-text> -->
</v-card>
</template>

<script>
import VueApexCharts from 'vue-apexcharts';
export default {
    components: {
        VueApexCharts,
    },
    data() {
        return {}
    },
    created() {
        this.id = this.$route.params.id;
    },
    computed: {
        title() {
            return this.$attrs.chartInfo.title;
        },
        percent() {
            return this.$attrs.chartInfo.percent;
        },
        chartInfo() {
            const formatNumber = this.$attrs.chartInfo.formatNumber != undefined ? this.$attrs.chartInfo.formatNumber : 1;

            let chartInfo = {
                options: {
                    title: {
                        // text: this.$attrs.chartInfo.title,
                        // align: 'left'
                    },
                    noData: {
                        text: `no data`,
                        align: 'center',
                        verticalAlign: 'middle',
                        offsetX: 0,
                        offsetY: 0,
                        style: {
                            color: undefined,
                            fontSize: '14px',
                            fontFamily: undefined
                        }
                    },
                    xaxis: {
                        // categories: this.$attrs.chartInfo.categories,
                        labels: {
                            show: false
                        }
                    },
                }
            };
            if (!this.$attrs.chartInfo.noData) {
                chartInfo = {
                    series: this.$attrs.chartInfo.series,
                    options: {
                        stroke: {
                            show: true,
                            width: 8,
                            colors: ['transparent']
                        },
                        fill: {
                            opacity: 0.8
                        },
                        chart: {
                            type: 'bar',
                            // height: 350,
                            stacked: this.$attrs.chartInfo.stacked || false,
                            toolbar: {
                                show: false
                            },
                            // zoom: {
                            //     enabled: true
                            // }
                        },
                        plotOptions: {
                            // bar: {
                            //     horizontal: false,
                            //     columnWidth: '30%',
                            //     // borderRadius: 10
                            // },
                            bar: {
                                // borderRadius: 10,
                                columnWidth: this.$attrs.chartInfo.columnWidth || '33%',
                                dataLabels: {
                                    position: 'center', // top, center, bottom
                                    // formatter: function (val) {
                                    //     return val + 'b';
                                    // },
                                },

                            }
                        },
                        dataLabels: {
                            enabled: true,
                            formatter: function (val) {
                                return val.toFixed(formatNumber);
                            },
                            // offsetY: -20,
                            style: {
                                fontSize: '10px',
                                // colors: ["#fff"]
                            }
                        },
                        xaxis: {
                            categories: this.$attrs.chartInfo.categories,
                            labels: {
                                show: this.$attrs.chartInfo.labelsShowX || false
                            }
                        },
                        yaxis: {
                            tickAmount: this.$attrs.chartInfo.tickAmount || 4,
                            // logBase: this.$attrs.chartInfo.logBase || 10,
                            forceNiceScale: this.$attrs.chartInfo.forceNiceScale || true,
                            min: this.$attrs.chartInfo.minY || 0,
                            max: this.$attrs.chartInfo.maxY || undefined,
                            labels: {
                                show: true, //this.$attrs.chartInfo.labelsShowY || false,
                                formatter: function (val) {
                                    return val.toFixed(0);
                                },
                            }
                        },
                        grid: {
                            show: false,
                            xaxis: {
                                lines: {
                                    show: false
                                }
                            },
                            yaxis: {
                                lines: {
                                    show: false
                                }
                            },
                        },
                        annotations: {
                            position: 'front',
                            yaxis: this.$attrs.chartInfo.annotations
                        },
                        legend: {
                            position: 'bottom',
                            fontSize: "14px",
                            // offsetY: 40
                        },
                        tooltip: {
                            shared: false,
                            y: {
                                formatter: function (val) {
                                    return (val).toFixed(formatNumber)
                                }
                            }
                        }
                    }
                };
            }
            return chartInfo;
        }
    },
    methods: {
        // formatData(type, value) {
        //     return formatData(type, value);
        // },
    }
};
</script>
